import { FC } from 'react';

import { PanelLayout } from '../PanelLayout';
import { TestMetadata } from '../types';

export interface StandardLayoutProps {
  /** Custom class name for layout */
  className?: string;
  /** Test data IDs for layout */
  testMetadata?: TestMetadata;
  /** Areas */
  areaMap?: {
    header: string;
    body: string;
    footer: string;
  };
}

const StandardLayout: FC<StandardLayoutProps> = ({
  children,
  areaMap = {
    header: 'header',
    body: 'body',
    footer: 'footer',
  },
  ...otherProps
}) => {
  return (
    <PanelLayout
      slim={{
        columns: ['1fr'],
        rows: ['auto', '1fr', 'auto'],
        areas: [[areaMap.header], [areaMap.body], [areaMap.footer]],
      }}
      {...otherProps}
    >
      {children}
    </PanelLayout>
  );
};

export default StandardLayout;
